import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {PublishingOption, PublishingOptionsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GET_PUBLISHINGOPTION_URL = `${API_URL}/publishingoption/getpublishingoption`
const CREATE_PUBLISHINGOPTION_URL = `${API_URL}/publishingoption/addpublishingoption`
const UPDATE_PUBLISHINGOPTION_URL = `${API_URL}/publishingoption/updatepublishingoption`
const DELETE_PUBLISHINGOPTION_URL = `${API_URL}/publishingoption/deletepublishingoption`
const GET_PUBLISHINGOPTIONS_URL = `${API_URL}/publishingoption/getpublishingoptions`

const getPublishingOptions = (query: string): Promise<PublishingOptionsQueryResponse> => {
  return axios
    .get(`${GET_PUBLISHINGOPTIONS_URL}?${query}`)
    .then((d: AxiosResponse<PublishingOptionsQueryResponse>) => d.data)
}

const getPublishingOptionById = (id: ID): Promise<PublishingOption | undefined> => {
  return axios
    .get(`${GET_PUBLISHINGOPTION_URL}/${id}`)
    .then((response: AxiosResponse<Response<PublishingOption>>) => response.data)
    .then((response: Response<PublishingOption>) => response.data)
}

const createPublishingOption = (publishingoption: PublishingOption): Promise<PublishingOption | undefined> => {
  return axios
    .post(CREATE_PUBLISHINGOPTION_URL, publishingoption)
    .then((response: AxiosResponse<Response<PublishingOption>>) => response.data)
    .then((response: Response<PublishingOption>) => response.data)
}

const updatePublishingOption = (publishingoption: PublishingOption): Promise<PublishingOption | undefined> => {
  return axios
    .put(`${UPDATE_PUBLISHINGOPTION_URL}/${publishingoption.id}`, publishingoption)
    .then((response: AxiosResponse<Response<PublishingOption>>) => response.data)
    .then((response: Response<PublishingOption>) => response.data)
}

const deletePublishingOption = (publishingoptionId: ID): Promise<void> => {
  return axios.delete(`${DELETE_PUBLISHINGOPTION_URL}/${publishingoptionId}`).then(() => {})
}

const deleteSelectedPublishingOptions = (publishingoptionIds: Array<ID>): Promise<void> => {
  const requests = publishingoptionIds.map((id) => axios.delete(`${DELETE_PUBLISHINGOPTION_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getPublishingOptions, deletePublishingOption, deleteSelectedPublishingOptions, getPublishingOptionById, createPublishingOption, updatePublishingOption}
